import { setError } from 'store/actions/auth';
import { setApplicationStatus } from 'store/actions/loanApply';

export const handleCreateLoanError = (code, param, err, dispatch) => {
  if (!err.response) {
    dispatch(setError('connection'));
    return;
  }

  if (code === null) {
    param.fail?.(err.response);
    return;
  }

  const handlers = {
    // Pay reject
    1030: () => param.payRej?.(),

    // Fail cases
    23409: () => param.fail?.(err.response),
    100126: () => param.fail?.(err.response),
    14084: () => param.fail?.(err.response),
    100128: () => param.fail?.(err.response),

    // In process + double disburse
    100127: () => {
      param.inProcess?.();
      dispatch(setApplicationStatus('DISB_IN_PROCESS'));
      dispatch(setError('double_disburse'));
    },
    100129: () => {
      param.inProcess?.();
      dispatch(setApplicationStatus('DISB_IN_PROCESS'));
      dispatch(setError('double_disburse'));
    },

    // In process only
    100130: () => {
      param.inProcess?.();
      dispatch(setApplicationStatus('DISB_IN_PROCESS'));
    },

    // Specific disbursement errors
    11022: () => dispatch(setError('account_disbursement_error')),
    11023: () => dispatch(setError('saca_disbursement_error')),
    11024: () => dispatch(setError('nik_disbursement_error')),
    11025: () => dispatch(setError('cif_disbursement_error')),

    // Checking uker errors - handled in uker selection
    12001: () => dispatch(setError('contact-cs')),
    12002: () => dispatch(setError('system')),

    // Errors NIK & Acctno in whitelist
    11027: () => dispatch(setError('nik_disbursement_error')),
    11028: () => dispatch(setError('nik_disbursement_error')),
    11030: () => dispatch(setError('nik_disbursement_error')),
    11032: () => dispatch(setError('nik_disbursement_error')),
    11026: () => dispatch(setError('nik_disbursement_error')),
    11029: () => dispatch(setError('nik_disbursement_error')),
    11031: () => dispatch(setError('nik_disbursement_error'))
  };

  if (handlers[code]) {
    handlers[code]();
    return;
  } else {
    dispatch(setError('system'));
  }
};
